import { motion } from "framer-motion";
import { Server, ShieldCheck, LayoutGrid, FileCheck2, TrendingUp, ArrowUpRight } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";

const Tag = ({ children, dark }) => (
  <span className={`font-mono-d rounded-full border px-3 py-1 text-[11px] uppercase tracking-wider ${dark ? "border-white/25 text-white/85" : "border-[var(--ink)]/20 text-[var(--ink-2)]"}`}>{children}</span>
);

const Card = ({ className = "", children, testid, delay = 0 }) => (
  <Reveal delay={delay} className={className}>
    <motion.article whileHover={{ y: -6 }} transition={{ type: "spring", stiffness: 200, damping: 20 }} data-testid={testid} className="group relative flex h-full flex-col overflow-hidden rounded-[2px] border border-[var(--line)] bg-white/70 p-7 sm:p-9">
      {children}
    </motion.article>
  </Reveal>
);

export const Services = () => (
  <section id="leistungen" data-testid="services-section" className="border-t border-[var(--line)] bg-[var(--stone-2)]/60">
    <div className="mx-auto max-w-[1440px] px-5 py-24 sm:px-8 lg:px-12 lg:py-40">
      <SectionHead id="leistungen" eyebrow="02 — Leistungen" title={["Zwei Disziplinen.", <span key="i" className="italic text-[var(--clay)]">Ein Ergebnis.</span>]} />

      <div className="mt-16 grid auto-rows-auto gap-5 md:grid-cols-6 lg:mt-20">
        <Card className="md:col-span-6 lg:col-span-4 lg:row-span-2" testid="service-card-it">
          <div className="absolute inset-0">
            <img src="/img/server.jpg" alt="Server-Rack mit Netzwerkverkabelung" className="h-full w-full object-cover transition-transform duration-1000 ease-out group-hover:scale-105" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#141413] via-[#141413]/75 to-[#141413]/20" />
          </div>
          <div className="relative mt-auto flex min-h-[420px] flex-col justify-end lg:min-h-[560px]">
            <Server className="h-7 w-7 text-[#E3A68F]" />
            <h3 className="font-serif-d mt-6 text-4xl leading-tight text-[var(--stone)] sm:text-5xl">IT-Modernisierung</h3>
            <p className="mt-4 max-w-lg text-base leading-relaxed text-white/85">Bestandsaufnahme, Cloud-Migration, Microsoft 365, Backup und Cybersecurity. Wir bauen eine Infrastruktur, die dokumentiert ist und ohne den bisherigen Inhaber läuft.</p>
            <div className="mt-6 flex flex-wrap gap-2"><Tag dark>Cloud</Tag><Tag dark>Security</Tag><Tag dark>ERP</Tag><Tag dark>Dokumentation</Tag></div>
          </div>
        </Card>

        <Card className="md:col-span-3 lg:col-span-2" testid="service-card-raum" delay={0.1}>
          <LayoutGrid className="h-7 w-7 text-[var(--clay)]" />
          <h3 className="font-serif-d mt-8 text-3xl leading-tight">Arbeitsplatz&shy;architektur</h3>
          <p className="mt-3 text-base leading-relaxed text-[var(--ink-2)]">Raumkonzepte für hybrides Arbeiten, Licht, Akustik und Identität – geplant von einer Architektin.</p>
          <div className="relative mt-6 aspect-[16/10] overflow-hidden rounded-[2px]">
            <img src="/img/glass.jpg" alt="Büro mit Glastrennwand" className="h-full w-full object-cover transition-transform duration-1000 group-hover:scale-105" />
          </div>
        </Card>

        <Card className="md:col-span-3 lg:col-span-2" testid="service-card-security" delay={0.15}>
          <ShieldCheck className="h-7 w-7 text-[var(--clay)]" />
          <h3 className="font-serif-d mt-8 text-3xl leading-tight">Sicherheit & Compliance</h3>
          <p className="mt-3 text-base leading-relaxed text-[var(--ink-2)]">Zugriffsrechte, DSGVO, Notfallpläne. Die Fragen, die jeder Käufer stellt, sind vorab beantwortet.</p>
          <ArrowUpRight className="mt-auto h-6 w-6 self-end pt-6 text-[var(--ink)] transition-transform duration-500 group-hover:rotate-45" />
        </Card>

        <Card className="md:col-span-3" testid="service-card-duediligence" delay={0.1}>
          <FileCheck2 className="h-7 w-7 text-[var(--clay)]" />
          <h3 className="font-serif-d mt-8 text-3xl leading-tight">Due-Diligence-Paket</h3>
          <p className="mt-3 text-base leading-relaxed text-[var(--ink-2)]">Ein klares Dossier zu IT, Räumen und Prozessen – für Käufer, Banken und Berater.</p>
        </Card>

        <Card className="md:col-span-3" testid="service-card-wert" delay={0.15}>
          <div className="absolute inset-0 bg-[var(--clay)]" />
          <div className="relative flex h-full flex-col">
            <TrendingUp className="h-7 w-7 text-[var(--stone)]" />
            <h3 className="font-serif-d mt-8 text-3xl leading-tight text-[var(--stone)]">Wertsteigerungs&shy;strategie</h3>
            <p className="mt-3 text-base leading-relaxed text-white/90">Wir priorisieren Maßnahmen nach Wirkung auf den Verkaufspreis – nicht nach Technik-Wunschliste.</p>
          </div>
        </Card>
      </div>
    </div>
  </section>
);
